
import {React, useState, useEffect, useRef} from "react"
import {
  Box,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useMediaQuery,
} from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import { useStyle } from "../../context/styleContext/styleContext";
import ReactGA from 'react-ga4';


export default function FAQ(){

  const { style } = useStyle();
  const isMobile = useMediaQuery("(max-width:600px)");
  const [height, setHeight] = useState(window.innerHeight)
  useEffect(() => {
    function handleResize() {      
      setHeight(window.innerHeight)
  }  
    window.addEventListener('resize', handleResize)
  })

  const topContainer = useRef();
    useEffect(() => {
        // To make sure page starts from the top
        topContainer.current.scrollIntoView({ block: "end" });
    }, []);

  useEffect(() => {document.title = 'Parish Audio | State Of The Art State Of The Art Audio Processing | FAQ';}, []);

  ReactGA.send({
    hitType:"pageview",
    page:"FAQ",
    title:"FAQ",
  })

  const faqs = [
    {
      question: "How do I install the plugin?",
      answer: "You can download the installer from your account page. Once downloaded, follow the instructions based on your operating system (Windows or macOS).",
    },
    {
      question: "Can I use the plugin on multiple computers?",
      answer: "Yes! Each license allows up to 5 installations. You can manage your devices from the My Gear section of your account.",
    },
    {
      question: "Do you offer a free trial?",
      answer: "We currently do not offer a free trial, but we have a 14-day money-back guarantee if the plugin doesn’t meet your needs.",
    },
    {
      question: "What DAWs are supported?",
      answer: "Our plugins work in all major DAWs that support VST3 or AU formats, including Ableton Live, Logic Pro, FL Studio, Cubase, and Reaper.",
    },
    {
      question: "How do I get updates?",
      answer: "You'll receive an email notification when updates are available. You can also check the download page in your account for the latest version.",
    },
  ];

  return (
    <div style={{width:'95%', margin:'auto'}}>
    <Box
      sx={{
        maxWidth: "900px",
        margin: "auto",
        pl: isMobile ? 2 : 4,
        pr: isMobile ? 2 : 4,
        pt: isMobile ? 1 : 2,
        pb: isMobile ? 2 : 4,
        mt: 4,
        mb: 4,
        backgroundColor: style.color1,
        borderRadius: 2,
        color: style.color4,
      }}
    >
      <h1 ref={topContainer} className='h1-A' style={{marginTop:'0px', marginBottom:'20px', fontSize:'1.5em'}}>
        Frequently Asked Questions
      </h1>


      <Accordion
        
        sx={{
          boxShadow:10,
          backgroundColor: style.color1,
          color: style.color1,
          mb: 2,
          borderRadius: 1,
          "&:before": { display: "none" },
        }}
        >
        <AccordionSummary
          expandIcon={<ExpandMore sx={{ color: style.color2 }} />}
          sx={{
            fontSize: "1.2rem",
            fontWeight: "bold",
            backgroundColor: style.color1,
            filter:'brightness(1.2)',
            color:style.color4,
            borderRadius: 1,
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
          }}
        >
            How do I install my plugin?
          </AccordionSummary>
          <AccordionDetails
            sx={{ backgroundColor: style.color1, filter:'brightness(1.35)',fontSize: "1.1rem", color:style.color4, textAlign:'center' }}
          >
            <strong style={{fontSize:'1.15rem', filter:'brightness(0.75)', textAlign:'center', margin:'auto', width:'100%'}}>We recommend closing your DAW or host program prior to installation.</strong>

            <ul className='a' style={{fontSize: "1.1rem", filter:'brightness(0.75)', marginTop:'25px', textAlign:'left', marginLeft:'10px'}}>

              <li style={{marginBottom:'20px'}}>
                <strong>Step 1:</strong> Download the app installer from the <a href="/my-gear"><strong>My Gear</strong></a> page. 
              </li>
              <li style={{marginBottom:'20px'}}>
                <strong>Step 2:</strong> Run the app installer. This will install your plugin to the correct location so it can be recognized automatically by your DAW. 
              </li>
              <li style={{marginBottom:'20px'}}>
                <strong>Step 3:</strong> When you open the plugin for the first time, enter your email and password to unlock it.
              </li>
              <li style={{marginBottom:'20px'}}>
                <strong>Step 4:</strong> Enjoy!
              </li>
            </ul>

          </AccordionDetails>
        </Accordion>

        <Accordion
        
        sx={{
          boxShadow:10,
          backgroundColor: style.color1,
          color: style.color1,
          mb: 2,
          borderRadius: 1,
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMore sx={{ color: style.color2 }} />}
          sx={{
            fontSize: "1.1rem",
            fontWeight: "bold",
            backgroundColor: style.color1,
            filter:'brightness(1.2)',
            color:style.color4,
            borderRadius: 1,
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
          }}
        >
            Can I use the plugin on multiple devices?
          </AccordionSummary>
          <AccordionDetails
            sx={{ backgroundColor: style.color1, filter:'brightness(1.35)',fontSize: "1.1rem", color:style.color4 }}
          >
            <span style={{filter:'brightness(0.75)'}}>Yes! Each license automatically allows up to 5 installations. You can manage your devices from the <a href="/my-gear"><strong>My Gear</strong></a> section of your account.</span>
            <br />
            <br />
            <span style={{filter:'brightness(0.75)'}}>In certain circumstances, we may allow you to install on more than 5 devices. If you would like to request a higher limit please contact us at <a href="mailto:support@parishaudio.com"><strong>support@parishaudio.com</strong>.</a></span>
          </AccordionDetails>
        </Accordion>



        <Accordion
        
        sx={{
          boxShadow:10,
          backgroundColor: style.color1,
          color: style.color1,
          mb: 2,
          borderRadius: 1,
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMore sx={{ color: style.color2 }} />}
          sx={{
            fontSize: "1.2rem",
            fontWeight: "bold",
            backgroundColor: style.color1,
            filter:'brightness(1.2)',
            color:style.color4,
            borderRadius: 1,
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
          }}
        >
            Do you offer a free trial?
          </AccordionSummary>
          <AccordionDetails
             sx={{ backgroundColor: style.color1, filter:'brightness(1.35)',fontSize: "1.1rem", color:style.color4 }}
          >
            <span style={{filter:'brightness(0.75'}}>Yes! We offer a free a free 7 day trial when you sign up for a monthly subscription. You can cancel the subscription at any time. </span>

          </AccordionDetails>
        </Accordion>


        <Accordion
        
        sx={{
          boxShadow:10,
          backgroundColor: style.color1,
          color: style.color1,
          mb: 2,
          borderRadius: 1,
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMore sx={{ color: style.color2 }} />}
          sx={{
            fontSize: "1.2rem",
            fontWeight: "bold",
            backgroundColor: style.color1,
            filter:'brightness(1.2)',
            color:style.color4,
            borderRadius: 1,
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
          }}
        >
            What DAWs are supported?
          </AccordionSummary>
          <AccordionDetails
             sx={{ backgroundColor: style.color1, filter:'brightness(1.35)',fontSize: "1.1rem", color:style.color4 }}
          >
           <span style={{filter:'brightness(.75)'}}> Our plugins work in all major DAWs that support VST3, including <a target="_blank" rel="noopener noreferrer" href="https://www.ableton.com/en/live/">Ableton Live</a>, <a target="_blank" rel="noopener noreferrer" href="https://www.image-line.com/">FL Studio</a>, <a target="_blank" rel="noopener noreferrer" href="https://www.steinberg.net/cubase/">Cubase</a>, and <a target="_blank" rel="noopener noreferrer" href="https://www.reaper.fm/">Reaper</a>.</span>

          </AccordionDetails>
        </Accordion>





        <Accordion
        
        sx={{
          boxShadow:10,
          backgroundColor: style.color1,
          color: style.color1,
          mb: 2,
          borderRadius: 1,
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMore sx={{ color: style.color2 }} />}
          sx={{
            fontSize: "1.2rem",
            fontWeight: "bold",
            backgroundColor: style.color1,
            filter:'brightness(1.2)',
            color:style.color4,
            borderRadius: 1,
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
          }}
        >
            Are your plugins compatible with both Windows and Mac?
          </AccordionSummary>
          <AccordionDetails
             sx={{ backgroundColor: style.color1, filter:'brightness(1.35)',fontSize: "1.1rem", color:style.color4 }}
          >
            <span style={{filter:'brightness(0.75)'}}>Yes! All of our plugins are available for both Windows and Mac. </span>

          </AccordionDetails>
        </Accordion>

        <Accordion
        
        sx={{
          boxShadow:10,
          backgroundColor: style.color1,
          color: style.color1,
          mb: 2,
          borderRadius: 1,
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMore sx={{ color: style.color2 }} />}
          sx={{
            fontSize: "1.2rem",
            fontWeight: "bold",
            backgroundColor: style.color1,
            filter:'brightness(1.2)',
            color:style.color4,
            borderRadius: 1,
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
          }}
        >
            How do I cancel my subscription?
          </AccordionSummary>
          <AccordionDetails
             sx={{ backgroundColor: style.color1, filter:'brightness(1.35)',fontSize: "1.1rem", color:style.color4 }}
          >
           <span style={{filter:'brightness(0.75)'}}> You can manage or cancel your subscriptions on the  <a href="/manage-subscriptions"><strong>Manage Subscriptions</strong></a>  page.</span>

          </AccordionDetails>
        </Accordion>




        <Accordion
        
        sx={{
          boxShadow:10,
          backgroundColor: style.color1,
          color: style.color1,
          mb: 2,
          borderRadius: 1,
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMore sx={{ color: style.color2 }} />}
          sx={{
            fontSize: "1.2rem",
            fontWeight: "bold",
            backgroundColor: style.color1,
            filter:'brightness(1.2)',
            color:style.color4,
            borderRadius: 1,
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
          }}
        >
            If I cancel my subscription, do I immediately lose access to my plugins?
          </AccordionSummary>
          <AccordionDetails
             sx={{ backgroundColor: style.color1, filter:'brightness(1.35)',fontSize: "1.1rem", color:style.color4 }}
          >
            <ul className='a' style={{fontSize: "1.1rem"}}>
              <li style={{marginBottom:'15px', marginTop:'15px' }}>
                  If you cancel your subscription, your plugins will be available to use until the end of the billing period.
              </li>
            </ul>
            <ul className='a' style={{fontSize: "1.1rem"}}>
              <li style={{marginBottom:'15px', marginTop:'15px' }}>
                  You will <strong>not</strong> lose access to any plugins you have purchased separately. 
              </li>
            </ul>
            

          </AccordionDetails>
        </Accordion>

        <Accordion
        
        sx={{
          boxShadow:10,
          backgroundColor: style.color1,
          color: style.color1,
          mb: 2,
          borderRadius: 1,
          "&:before": { display: "none" },
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMore sx={{ color: style.color2 }} />}
          sx={{
            fontSize: "1.1rem",
            fontWeight: "bold",
            backgroundColor: style.color1,
            filter:'brightness(1.2)',
            color:style.color4,
            borderRadius: 1,
            "& .MuiAccordionSummary-content": {
              margin: 0,
            },
          }}
        >
            Can I use my plugin without an internet connection?
          </AccordionSummary>
          <AccordionDetails
             sx={{ backgroundColor: style.color1, filter:'brightness(1.35)',fontSize: "1.1rem", color:style.color4 }}
          >

            <span style={{filter:'brightness(0.75)'}}>Yes! Our plugins work without an internet connection, with the following exceptions:</span>

            <ul className='a' style={{fontSize: "1.1rem", filter:'brightness(0.75)'}}>
              <li style={{marginBottom:'15px', marginTop:'15px' }}>
                  An internet connection is required to authenticate and unlock the plugin the first time you use it. 
              </li>
              <li style={{marginBottom:'15px', marginTop:'15px' }}>
                  If you manually log out of a plugin, an internet connection will be required to log back in.
              </li>
              <li style={{marginBottom:'15px', marginTop:'15px' }}>
                  For subscriptions - the plugin will need to access the internet at the beginning of each billing period to verify the subscription is still active. After this has been verified, the plugin can work offline until the next billing period. 
              </li>
            </ul>

            

          </AccordionDetails>
        </Accordion>

    </Box>
    </div>
  );
}

